export const ADD_CART = 'ADD_CART';
export const SET_CART = 'SET_CART';
export const GET_PRODUCT = 'GET_PRODUCT';
export const CLEAR_CART = 'CLEAR_CART';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
